<template>
  <div class='UserList' :class="{ gray: isPar(chave) }">
    <div class="c-user">
      {{ data.usuario }}
    </div>
    <div style="width: 16%" class="mobile-none">
      {{ data.nome }}
    </div>
    <div style="width: 16%" class="mobile-none">
      {{ data.sobrenome }}
    </div>
    <div class="c-email">
      {{ data.email }}
    </div>
    <div class="cont-status">
      <div :class="{ status: data.status, disable: !data.status }"></div>
    </div>
    <div class="action">
      <disable-icon @click="UpdateUser({ payload: data, status: 0 })" v-if="data.status"/>
      <checked-icon @click="UpdateUser({ payload: data, status: 1 })" v-if="!data.status"/>
      <edit-icon @click="update"/>
      <delete-icon @click="del"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditIcon from '../../Icons/EditIcon'
import DeleteIcon from '../../Icons/DeleteIcon'
import DisableIcon from '../../Icons/DisableIcon'
import CheckedIcon from '../../Icons/CheckedIcon'
export default {
  name: 'UserList',
  props: ['data', 'chave'],
  components: { EditIcon, DeleteIcon, DisableIcon, CheckedIcon },
  methods: {
    ...mapActions(['SetModal', 'UpdateUser', 'SetUserEdit']),
    del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o usuário?',
        action: 'DeleteUser',
        payload: this.data
      })
    },
    update () {
      this.SetUserEdit(this.data)
        .then(() => this.$router.push('/painel/user/edit'))
    },
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    }
  }
}
</script>

<style scoped>
.UserList {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.action {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16%;
}

.cont-status {
  display: flex;
  justify-content: center;
  width: 5%;
}

.status {
  width: 10px;
  height: 10px;
  background-color: green;
  padding: 2%;
  border-radius: 50%;
  color: #FFFFFF;
}

.disable {
  width: 10px;
  height: 10px;
  background-color: red;
  padding: 2%;
  border-radius: 50%;
  color: #FFFFFF;
}

.gray {
  background-color: #F5F5F5F5;
}

.c-user {
  width: 18%;
}

.c-email {
  width: 29%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-user {
    width: 20%;
  }
  .c-email {
    width: 40%;
  }
  .cont-status {
    width: 20%;
  }
  .action {
    width: 20%;
  }
}
</style>
